module.exports = __webpack_public_path__ + "static/media/logo-white.84effaa8.svg";